import { SetCodeEnum, VariantProductEnum } from "@sorcery/db";
import { cn } from "@sorcery/ui";

import { Alpha } from "../atoms/sets/Alpha";
import { Arthurian } from "../atoms/sets/Arthurian";
import { Beta } from "../atoms/sets/Beta";
import { Spiral } from "../atoms/sets/Spiral";

const setToComponentMap = {
  [SetCodeEnum.alp]: Alpha,
  [SetCodeEnum.bet]: Beta,
  [SetCodeEnum.art]: Arthurian,
};

const productOverrides: VariantProductEnum[] = [
  VariantProductEnum.Draft_Kit,
  VariantProductEnum.Store_Kit,
  VariantProductEnum.Promo,
];

export const SetSymbol = ({
  set,
  product,
  color = "white",
  className = "",
}: {
  set: SetCodeEnum;
  product: VariantProductEnum;
  color?: "black" | "white";
  className?: string;
}) => {
  const SVG = productOverrides.includes(product) ? Spiral : (setToComponentMap[set] ?? Spiral);
  return (
    <span className={cn("inline-block h-[26px] w-[26px]", className)}>{<SVG color={color} />}</span>
  );
};
